import React from "react";

/* Takes in a user Object from the API and returns the number and email for a tooltip. */
export const toolTipContactDetails = (user) => {
  return (
    <>
      {user ? (
        <>
          {`Email: ${user.email}`}
          <br />
          {user.phone_number ? `Number: ${user.phone_number}` : null}
        </>
      ) : null}
    </>
  );
};
